export default __webpack_public_path__ + "static/media/AWS_logo.7e69599a.png";